import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // optional for better user experience

// Import your translation files
import translationEN from './locales/en/translation.json';
import translationMS from './locales/ms/translation.json';
import translationTH from './locales/th/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  ms: {
    translation: translationMS,
  },
  th:{
    translation: translationTH,
  }
};

i18n
  .use(LanguageDetector) // optional
  .use(initReactI18next) // pass the i18n instance to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en', // set initial language from localStorage or default to 'en'
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      // optional settings for language detection
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
